
import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "PopupIdentityMismatch",
  components: {
    NewConfirmPopup: () => import("@/modules/Documents/NewConfirmPopup.vue"),
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["update:modelValue", "ok", "cancel"],

  setup(props, { emit }) {
    function close() {
      emit("update:modelValue", false);
    }

    function onOk() {
      emit("ok");

      close();
    }

    function onCancel() {
      emit("cancel");

      close();
    }

    return {
      onCancel,
      onOk,
    };
  },
});
